export const CASES = {
    UPDATE_JOB_TASKS: 'UPDATE_JOB_TASKS',
    UPDATE_JOB_TASKS_FORM: 'UPDATE_JOB_TASKS_FORM',
    CLEAR_JOB_TASKS: 'CLEAR_JOB_TASKS',
};
